import { DateObject } from '@uplift/services';
import { Timeslot } from './types';

export const sortTimeSlots = (slots: Timeslot[]) => {
  return [ ...slots ].sort((a, b) => a.toISOString().localeCompare(b.toISOString()));
};

export const enum DayPartEnum {
  Morning = 'Morning',
  Afternoon = 'Afternoon',
  Evening = 'Evening',
}

export const getDayPart = (time: Timeslot) => {
  const hour = time.get('hour');

  if (hour < 12) {
    return DayPartEnum.Morning;
  } else if (hour < 17) {
    return DayPartEnum.Afternoon;
  } else {
    return DayPartEnum.Evening;
  }
};

type DayPartingMap = {
  [key in DayPartEnum]: Timeslot[];
};

// since the slots are sorted, these will be in the proper order
// not setting initial value to object with empty arrays, so that only the parts with results will render
export const getDayPartedSlots = (slots: Timeslot[]) => {
  const dayPartingInitialValue = {} as DayPartingMap;

  return slots.reduce((r, slot) => {
    const dayPart = getDayPart(slot);

    return { ...r, [dayPart]: r?.[dayPart] ? [ ...r[dayPart], slot ] : [ slot ] };
  }, dayPartingInitialValue);
};

export const getTimeSlotsForDate = (timeslots: Timeslot[], date: DateObject) => {
  return timeslots.filter((timeSlot) => timeSlot.startOf('day').isSame(date));
};

export const getTriadTimeSlotsForDate = (timeslots: Timeslot[], date: DateObject) => {
  return Array.from({ length: 3 }, (_, i) => getTimeSlotsForDate(timeslots, date.add(i, 'day')));
};

export const DATE_HASH_FORMAT = 'YYYY-MM-DD';

type TimeslotHashType = {
  [key: string]: Timeslot[];
};

export const getSlotHash = (slots: Timeslot[]) => {
  return slots.reduce((r, timeslot) => {
    const keyFormatted = timeslot.format(DATE_HASH_FORMAT);

    return { ...r, [keyFormatted]: r?.[keyFormatted] ? [ ...r[keyFormatted], timeslot ] : [ timeslot ]  };
  }, {} as TimeslotHashType);
};

export const getTimeSlotsForDateFromHash = (timeslotHash: TimeslotHashType, date: DateObject) => {
  const key = date.format(DATE_HASH_FORMAT);

  return timeslotHash[key] ?? [];
};

export const getTriadTimeSlotsForDateFromHash = (timeslotHash: TimeslotHashType, date: DateObject) => {
  return Array.from({ length: 3 }, (_, i) => getTimeSlotsForDateFromHash(timeslotHash, date.add(i, 'day')));
};
